function getBaseUrl() {
  if (window.baseAxios) {
    return window.baseAxios.baseUrl;
  } else {
    return '//lvapi.liveme.com';
  }
}
function getCmsBaseUrl() {
  if (window.baseAxios) {
    return window.baseAxios.cmsBaseUrl;
  } else {
    return '//lvapi.liveme.com/cms-glb';
  }
}
function getCmsApi() {
  if (window.baseAxios) {
    return window.baseAxios.cmsAPI;
  } else {
    return '//lvapi.liveme.com/cms-glb';
  }
}
var hosts = {
  getBase: function getBase() {
    return {
      baseUrl: getBaseUrl(),
      cmsBaseUrl: getCmsBaseUrl(),
      cmsAPI: getCmsApi()
    };
  }
};
export default hosts;